<template>
  <div class="vd-gl-content">
    <a-tabs :defaultActiveKey="key">
      <a-tab-pane key="update" tab="更新日志">
        <div class="markdown-body" v-html="platformMd"></div>
      </a-tab-pane>
      <a-tab-pane key="editor" tab="编辑器操作文档">
        <div class="markdown-body" v-html="editorMd"></div>
      </a-tab-pane>
      <a-tab-pane key="auto" tab="职位检索小程序">
        <div class="markdown-body" v-html="Auto"></div>
      </a-tab-pane>
      <a-tab-pane key="bookTool" tab="白皮书操作文档">
        <div class="markdown-body" v-html="bookTool"></div>
      </a-tab-pane>
      <a-tab-pane key="qqTool" tab="QQ社群操作文档">
        <div class="markdown-body" v-html="qqTool"></div>
      </a-tab-pane>
      <a-tab-pane key="programMd" tab="小程序接口文档">
        <div class="markdown-body" v-html="programMd"></div>
      </a-tab-pane>
      <a-tab-pane key="bookMd" tab="白皮书接口文档">
        <div class="markdown-body" v-html="bookMd"></div>
      </a-tab-pane>
    </a-tabs>
    <Top />
  </div>
</template>

<script>
import Top from '@/components/top'
import platform_md from '@/assets/md/platform.md'
import editor_md from '@/assets/md/editor.md'
import program_api from '@/assets/md/program_api.md'
import book_api from '@/assets/md/book_api.md'
import book_tool from '@/assets/md/book_tool.md'
import qq_tool from '@/assets/md/qq.md'
import auto from '@/assets/md/auto.md'

import marked from 'marked'
import hljs from 'highlight.js'
import 'highlight.js/styles/dark.css'
import 'github-markdown-css'

marked.setOptions({
  highlight: (code, lang) => {
    return hljs.highlight(lang, code).value
  },
})

const platformMd = marked(platform_md).replace(/<pre>/g, "<pre class='hljs'>")
const editorMd = marked(editor_md).replace(/<pre>/g, "<pre class='hljs'>")
const programMd = marked(program_api).replace(/<pre>/g, "<pre class='hljs'>")
const bookMd = marked(book_api).replace(/<pre>/g, "<pre class='hljs'>")
const bookTool = marked(book_tool).replace(/<pre>/g, "<pre class='hljs'>")
const qqTool = marked(qq_tool).replace(/<pre>/g, "<pre class='hljs'>")
const Auto = marked(auto).replace(/<pre>/g, "<pre class='hljs'>")

export default {
  name: 'Index',
  components: { Top },
  data() {
    return {
      qqTool,
      platformMd,
      editorMd,
      programMd,
      bookMd,
      bookTool,
      Auto,
      key: 'update',
    }
  },
  created() {
    const { query } = this.$route
    if (!this.$HelperUtil.isEmpty(query)) {
      this.key = query.key
    }
  },
}
</script>

<style scoped></style>
